module.exports = __webpack_public_path__ + "static/media/korn-ferry.7caf125b.svg";